import React, { useCallback, useState } from 'react';

import { App, Button, Modal, Typography } from 'antd';

import { useMutation } from '@tanstack/react-query';
import { cdfService } from 'v2/services/cdfService';
import type { IFilterParams } from 'v2/services/cdfService/types';
import { useUserStore } from 'v2/store/User';

interface IProps {
  open: boolean;
  onClose: any;
  filterParams: IFilterParams;
}

const ModalReport: React.FC<IProps> = ({ open, onClose, filterParams }) => {
  const { message } = App.useApp();
  const [finished, setFinished] = useState(false);

  const exportMutation = useMutation({
    mutationFn: (params: IFilterParams) => cdfService.export(params),
    onSuccess: () => {
      setFinished(true);
    },
    onError: () => {
      message.error('Ops, erro ao tentar gerar relatório!');
    }
  });

  const { email } = useUserStore(({ originalUser }) => ({ email: originalUser.email }));

  const handleSubmit = useCallback(async () => {
    exportMutation.mutate(filterParams);
  }, [exportMutation, filterParams]);

  const handleClose = useCallback(() => {
    setFinished(false);
    onClose();
  }, [onClose]);

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title='Geração de relatório de documentos fiscais'
      width={640}
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' disabled={exportMutation.isPending} onClick={handleClose}>
            Fechar
          </Button>
          {!finished && (
            <Button
              loading={exportMutation.isPending}
              disabled={exportMutation.isPending}
              type='primary'
              onClick={handleSubmit}
            >
              {exportMutation.isPending ? 'Gerando...' : 'Gerar'}
            </Button>
          )}
        </div>
      }
    >
      {finished ? (
        <Typography.Paragraph className='mb-0'>
          Geração do relatório solicitado com sucesso, você irá receber o relatório no e-mail{' '}
          <Typography.Text strong>{email}</Typography.Text> quando o processo finalizar.
        </Typography.Paragraph>
      ) : (
        <Typography.Paragraph className='mb-0'>
          Ao gerar o relatório você irá receber uma cópia no e-mail <Typography.Text strong>{email}</Typography.Text>{' '}
          assim que o processo for finalizado.
        </Typography.Paragraph>
      )}
    </Modal>
  );
};

export default ModalReport;
